// extracted by mini-css-extract-plugin
export var quantityInput = "_n2-0";